import Image from 'next/image'
import React from 'react'

import { classNames } from '@lib/simpleFn'

type NextButtonProps = {
  isVisible: boolean
  isBackward: boolean
  movePageHandler: () => void
}

const MoveButtonView: React.FC<NextButtonProps> = ({ isVisible, isBackward, movePageHandler }) => {
  return (
    <button
      className={classNames(
        'py-1 border-2 h-11 w-10 sm:w-[88px] border-eaeaea rounded-lg bg-white',
        !isVisible ? 'invisible' : '',
        isBackward ? 'mr-3 pl-2 pr-1' : 'ml-3 pr-2 pl-1'
      )}
      onClick={isVisible ? movePageHandler : undefined}
    >
      {isBackward ? (
        <div className={'flex'}>
          <Image
            className={'my-auto mx-1'}
            src={'/exam/previousArrow.png'}
            alt={'nextArrow'}
            width={'8'}
            height={'16'}
          />
          <h3 className={'max-[640px]:hidden my-auto text-xl mx-1'}>이전</h3>
        </div>
      ) : (
        <div className={'flex'}>
          <h3 className={'max-[640px]:hidden sm:flex my-auto text-xl mx-2'}>다음</h3>
          <Image
            className={'my-auto ml-2 sm:mx-1'}
            src={'/exam/nextArrow.png'}
            alt={'nextArrow'}
            width={'8'}
            height={'16'}
          />
        </div>
      )}
    </button>
  )
}

export default MoveButtonView
